import {RouteRecordRaw} from "vue-router";
import moduleZewRoutings from "@/router/route/moduleZewRoutings";
import moduleToDoRoutings from "@/router/route/moduleToDoRoutings";

const moduleRoutings: Array<RouteRecordRaw> = [
    /*----------------------*/
    /*----- module zew -----*/
    /*----------------------*/
    ...moduleZewRoutings,
    /*-----------------------*/
    /*----- module ToDo -----*/
    /*-----------------------*/
    ...moduleToDoRoutings,
];

export default moduleRoutings;
